import script from "./CompaniesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompaniesList.vue?vue&type=script&lang=ts&setup=true"

import "./CompaniesList.vue?vue&type=style&index=0&id=f783ead2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f783ead2"]])

export default __exports__